var Cube = require('cube-js')
var app = function() {
  this.action_list = {};
}

Cube.mix(app.prototype, {

  action_list: {},
  last_action: null,

  on: function(action, start_callback, stop_callback) {
    this.action_list[action] = [start_callback, stop_callback];
  },

  do: function(action) {
    if (this.last_action == action) {
      return;
    }
    if (this.last_action) {
      this.action_list[this.last_action][1]();
    }
    this.last_action = action;
    this.action_list[this.last_action][0]();
  },
});
module.exports = app;



//////////////////
// WEBPACK FOOTER
// ./src/js/reverse-action.js
// module id = 51
// module chunks = 3